import { isNewVersionAvailable } from '@/utils/appUtils';
import { getSubscriptions, getSubscriptionsStatus } from '@/api/billing';
import store from '@/store';
import { UndoRedoManager } from '@/utils/undoRedoManager/undoRedoManager.js';

(function () {
    'use strict';
    'ngInject';
    angular.module('app.ctrls').controller('HeadCtrl', headCtrl);

    function headCtrl($scope, $location, $timeout, $interval, $rootScope) {
        if ($rootScope.user) {
            $scope.isManaged = $rootScope.user.User_Id ? true : false;
        }
        $scope.newAppVersionAvailable = false;
        $scope.subscription = {
            Status: 'active'
        };
        $scope.accountBannerType = null;
        $scope.accountBannerSubscription = null;
        $scope.undoManager = new UndoRedoManager();
        $scope.forDesignTemplateCreation = !!$location.search().forDesignTemplateCreation;

        function applyBannerFromSubscriptions(subscriptions) {
            var pausedSubscription = (subscriptions || []).find(
                (s) => s.Status === 'paused' || s.Status === 'paused_past_due'
            );
            if (pausedSubscription) {
                $scope.accountBannerType = 'paused';
                $scope.accountBannerSubscription = pausedSubscription;
                return;
            }

            var unpaidSubscription = (subscriptions || []).find((s) => s.Status === 'unpaid');
            if (unpaidSubscription) {
                $scope.accountBannerType = 'unpaid';
                $scope.accountBannerSubscription = unpaidSubscription;
                return;
            }

            var canceledSubscription = (subscriptions || []).find((s) => s.Status === 'canceled');
            if (canceledSubscription) {
                $scope.accountBannerType = 'canceled';
                $scope.accountBannerSubscription = null;
                return;
            }

            $scope.accountBannerType = 'disabled';
            $scope.accountBannerSubscription = null;
        }

        // Guards against a late API response overwriting a newer call's result.
        var latestCall = 0;
        function setAccountBannerType(user) {
            var thisCall = ++latestCall;

            if (user && user.Canceled) {
                $scope.accountBannerType = 'canceled';
                $scope.accountBannerSubscription = null;
                $timeout(() => $scope.$apply());
                return;
            }

            if (user && user.IsDisabled) {
                getSubscriptionsStatus()
                    .then((subscriptions) => {
                        if (thisCall !== latestCall) {
                            return;
                        }
                        applyBannerFromSubscriptions(subscriptions);
                        $timeout(() => $scope.$apply());
                    })
                    .catch((error) => {
                        if (error.response?.status !== 401) {
                            window.rumReportError(error);
                        }
                        if (thisCall !== latestCall) {
                            return;
                        }
                        $scope.accountBannerType = 'disabled';
                        $scope.accountBannerSubscription = null;
                        $timeout(() => $scope.$apply());
                    });
                return;
            }

            // No user, or user is neither canceled nor disabled: no banner.
            $scope.accountBannerType = null;
            $scope.accountBannerSubscription = null;
            $timeout(() => $scope.$apply());
        }

        $rootScope.$watch('user', setAccountBannerType);

        // Check app version every 10 minutes
        $interval(() => {
            isNewVersionAvailable()
                .then((data) => {
                    if (data.isNewVersion) {
                        console.log(`New app version available: ${data.version}`);
                        $scope.newAppVersionAvailable = true;
                    } else {
                        $scope.newAppVersionAvailable = false;
                    }

                    $timeout(() => $scope.$apply());
                })
                .catch((error) => {
                    console.error(error);
                    window.rumReportError(error);
                });
        }, 60 * 10 * 1000);

        // Watch for subscriptions change
        store.watch(
            (state) => {
                return state.subscriptions;
            },
            (subscriptions) => {
                $scope.subscription = subscriptions.filter((s) => s.Status !== 'active' && s.Status !== 'trialing')[0];
                $timeout(() => $scope.$apply());
            }
        );

        if ($rootScope.user) {
            if (store.state.subscriptions && store.state.subscriptions.length) {
                $scope.subscription = store.state.subscriptions.filter(
                    (s) => s.Status !== 'active' && s.Status !== 'trialing'
                )[0];
                $timeout(() => $scope.$apply());
            } else {
                getSubscriptions()
                    .then((subscriptions) => {
                        store.commit('subscriptions', subscriptions);
                    })
                    .catch((e) => {
                        if (e.response?.status !== 401) {
                            window.rumReportError(e);
                        }
                    });
            }
        }

        $scope.goToAccount = function (store) {
            $location.path('/account/billing').search({
                store: store
            });
        };

        $scope.refreshPage = function () {
            location.reload();
        };

        $scope.onResizeBtnClick = function () {
            $rootScope.$broadcast('template:resize-btn-click');
        };

        $scope.onCreatePageEpsClick = function () {
            $rootScope.$broadcast('template:create-page-eps-btn-click');
        };

        $scope.openProductSpecsModalOpen = function () {
            $rootScope.$broadcast('template:product-specs-btn-click');
        };
    }
})();
